import { ArticleFormData } from 'mk2/apps/blogs/components/ArticleCreateEditForm';
import { ArticleEditSaveActionType } from 'mk2/apps/blogs/containers/ArticleEdit/ArticleEdit.constants';
import { FormPageType } from 'mk2/constants/enums';
import { PhotosUploadConfig } from 'mk2/containers/PhotosUpload/PhotosUpload';
import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';

///////////////////////////////////////////////////////////////////
// ArticleEdit load

export const ARTICLE_EDIT_FETCH_TRIGGER = 'ARTICLE_EDIT_FETCH_TRIGGER';
export interface ArticleEditFetchTriggerAction {
    readonly type: typeof ARTICLE_EDIT_FETCH_TRIGGER;
    readonly username: string;
    readonly articleSlug: string;
}
export const ARTICLE_EDIT_FETCH_REQUEST = 'ARTICLE_EDIT_FETCH_REQUEST';
export interface ArticleEditFetchRequestAction extends APIRequestAction {
    readonly type: typeof ARTICLE_EDIT_FETCH_REQUEST;
    readonly username: string;
    readonly articleSlug: string;
}
export interface ArticleEditFetchNormalizedResponse extends NormalizedResponse {
    readonly result: {
        post: number;
    };
}
export const ARTICLE_EDIT_FETCH_SUCCESS = 'ARTICLE_EDIT_FETCH_SUCCESS';
export interface ArticleEditFetchSuccessAction extends APISuccessAction<ArticleEditFetchNormalizedResponse> {
    readonly type: typeof ARTICLE_EDIT_FETCH_SUCCESS;
    readonly username: string;
    readonly articleSlug: string;
}
export const ARTICLE_EDIT_FETCH_FAILURE = 'ARTICLE_EDIT_FETCH_FAILURE';
export interface ArticleEditFetchFailureAction extends APIFailureAction {
    readonly type: typeof ARTICLE_EDIT_FETCH_FAILURE;
    readonly username: string;
    readonly articleSlug: string;
}

export const articleEditFetchTrigger =
    (username: string, articleSlug: string): ArticleEditFetchTriggerAction => ({
        type: ARTICLE_EDIT_FETCH_TRIGGER, username, articleSlug,
    });
export const articleEditFetchApi = {
    request: (username: string, articleSlug: string): ArticleEditFetchRequestAction => ({
        type: ARTICLE_EDIT_FETCH_REQUEST, username, articleSlug,
    }),
    success: (username: string, articleSlug: string, response: ArticleEditFetchNormalizedResponse): ArticleEditFetchSuccessAction => ({
        type: ARTICLE_EDIT_FETCH_SUCCESS, username, articleSlug, response,
    }),
    failure: (username: string, articleSlug: string, error: any): ArticleEditFetchFailureAction => ({
        type: ARTICLE_EDIT_FETCH_FAILURE, username, articleSlug, error,
    }),
};

///////////////////////////////////////////////////////////////////
// ArticleEdit Change Editor

export const ARTICLE_EDIT_CHANGE_EDITOR_TYPE_TRIGGER = 'ARTICLE_EDIT_CHANGE_EDITOR_TYPE_TRIGGER';
export interface ArticleEditChangeEditorTypeTriggerAction {
    readonly type: typeof ARTICLE_EDIT_CHANGE_EDITOR_TYPE_TRIGGER;
    readonly username: string;
    readonly articleSlug: string;
    readonly editorType: number;
}
export const ARTICLE_EDIT_CHANGE_EDITOR_TYPE_REQUEST = 'ARTICLE_EDIT_CHANGE_EDITOR_TYPE_REQUEST';
export interface ArticleEditChangeEditorTypeRequestAction extends APIRequestAction {
    readonly type: typeof ARTICLE_EDIT_CHANGE_EDITOR_TYPE_REQUEST;
    readonly username: string;
    readonly articleSlug: string;
    readonly editorType: number;
}
export const ARTICLE_EDIT_CHANGE_EDITOR_TYPE_SUCCESS = 'ARTICLE_EDIT_CHANGE_EDITOR_TYPE_SUCCESS';
export interface ArticleEditChangeEditorTypeSuccessAction extends APISuccessAction {
    readonly type: typeof ARTICLE_EDIT_CHANGE_EDITOR_TYPE_SUCCESS;
    readonly username: string;
    readonly articleSlug: string;
    readonly editorType: number;
}
export const ARTICLE_EDIT_CHANGE_EDITOR_TYPE_FAILURE = 'ARTICLE_EDIT_CHANGE_EDITOR_TYPE_FAILURE';
export interface ArticleEditChangeEditorTypeFailureAction extends APIFailureAction {
    readonly type: typeof ARTICLE_EDIT_CHANGE_EDITOR_TYPE_FAILURE;
    readonly username: string;
    readonly articleSlug: string;
    readonly editorType: number;
}

export const articleEditChangeEditorTypeTrigger =
    (username: string, articleSlug: string, editorType: number): ArticleEditChangeEditorTypeTriggerAction => ({
        type: ARTICLE_EDIT_CHANGE_EDITOR_TYPE_TRIGGER, username, articleSlug, editorType,
    });
export const articleEditChangeEditorTypeApi = {
    request: (username: string, articleSlug: string, editorType: number): ArticleEditChangeEditorTypeRequestAction => ({
        type: ARTICLE_EDIT_CHANGE_EDITOR_TYPE_REQUEST, username, articleSlug, editorType,
    }),
    success: (username: string, articleSlug: string, editorType: number, response: any): ArticleEditChangeEditorTypeSuccessAction => ({
        type: ARTICLE_EDIT_CHANGE_EDITOR_TYPE_SUCCESS, username, articleSlug, editorType, response,
    }),
    failure: (username: string, articleSlug: string, editorType: number, error: any): ArticleEditChangeEditorTypeFailureAction => ({
        type: ARTICLE_EDIT_CHANGE_EDITOR_TYPE_FAILURE, username, articleSlug, editorType, error,
    }),
};

///////////////////////////////////////////////////////////////////
// ArticleEdit Save Article

export const ARTICLE_EDIT_SAVE_ARTICLE_TRIGGER = 'ARTICLE_EDIT_SAVE_ARTICLE_TRIGGER';
export interface ArticleEditSaveArticleTriggerAction {
    readonly type: typeof ARTICLE_EDIT_SAVE_ARTICLE_TRIGGER;
    readonly username: string;
    readonly articleSlug: string;
    readonly articleId: number;
    readonly articleFd: ArticleFormData;
    readonly saveActionType: ArticleEditSaveActionType;
}
export const ARTICLE_EDIT_SAVE_ARTICLE_REQUEST = 'ARTICLE_EDIT_SAVE_ARTICLE_REQUEST';
export interface ArticleEditSaveArticleRequestAction extends APIRequestAction {
    readonly type: typeof ARTICLE_EDIT_SAVE_ARTICLE_REQUEST;
    readonly username: string;
    readonly articleSlug: string;
    readonly articleId: number;
    readonly articleFd: ArticleFormData;
    readonly saveActionType: ArticleEditSaveActionType;
}
export interface ArticleEditSaveNormalizedResponse extends NormalizedResponse {
    readonly result: {
        post: number;
    };
}
export const ARTICLE_EDIT_SAVE_ARTICLE_SUCCESS = 'ARTICLE_EDIT_SAVE_ARTICLE_SUCCESS';
export interface ArticleEditSaveArticleSuccessAction extends APISuccessAction<ArticleEditSaveNormalizedResponse> {
    readonly type: typeof ARTICLE_EDIT_SAVE_ARTICLE_SUCCESS;
    readonly username: string;
    readonly articleSlug: string;
    readonly articleId: number;
    readonly articleFd: ArticleFormData;
    readonly saveActionType: ArticleEditSaveActionType;
}
export const ARTICLE_EDIT_SAVE_ARTICLE_FAILURE = 'ARTICLE_EDIT_SAVE_ARTICLE_FAILURE';
export interface ArticleEditSaveArticleFailureAction extends APIFailureAction {
    readonly type: typeof ARTICLE_EDIT_SAVE_ARTICLE_FAILURE;
    readonly username: string;
    readonly articleSlug: string;
    readonly articleId: number;
    readonly articleFd: ArticleFormData;
    readonly saveActionType: ArticleEditSaveActionType;
}

export const articleEditSaveArticleTrigger =
    (username: string, articleSlug: string, articleId: number, articleFd: ArticleFormData, saveActionType: ArticleEditSaveActionType): ArticleEditSaveArticleTriggerAction => ({
        type: ARTICLE_EDIT_SAVE_ARTICLE_TRIGGER, username, articleSlug, articleId, articleFd, saveActionType,
    });
export const articleEditSaveArticleApi = {
    request: (username: string, articleSlug: string, articleId: number, articleFd: ArticleFormData, saveActionType: ArticleEditSaveActionType): ArticleEditSaveArticleRequestAction => ({
        type: ARTICLE_EDIT_SAVE_ARTICLE_REQUEST, username, articleSlug, articleId, articleFd, saveActionType,
    }),
    success: (username: string, articleSlug: string, articleId: number, articleFd: ArticleFormData, saveActionType: ArticleEditSaveActionType, response: ArticleEditSaveNormalizedResponse): ArticleEditSaveArticleSuccessAction => ({
        type: ARTICLE_EDIT_SAVE_ARTICLE_SUCCESS, username, articleSlug, articleId, articleFd, saveActionType, response,
    }),
    failure: (username: string, articleSlug: string, articleId: number, articleFd: ArticleFormData, saveActionType: ArticleEditSaveActionType, error: any): ArticleEditSaveArticleFailureAction => ({
        type: ARTICLE_EDIT_SAVE_ARTICLE_FAILURE, username, articleSlug, articleId, articleFd, saveActionType, error,
    }),
};

///////////////////////////////////////////////////////////////////
// ArticleEdit Insert image

export const ARTICLE_EDIT_INSERT_IMAGE_TRIGGER = 'ARTICLE_EDIT_INSERT_IMAGE_TRIGGER';
export interface ArticleEditInsertImageTriggerAction {
    readonly type: typeof ARTICLE_EDIT_INSERT_IMAGE_TRIGGER;
    readonly editor: any;
    readonly formName: string;
    readonly config: PhotosUploadConfig;
    readonly files: File[];
    readonly processPhotoUploadOnFormPage: FormPageType;
    readonly accessKey?: string;
}
export const ARTICLE_EDIT_INSERT_IMAGE_REQUEST = 'ARTICLE_EDIT_INSERT_IMAGE_REQUEST';
export interface ArticleEditInsertImageRequestAction extends APIRequestAction {
    readonly type: typeof ARTICLE_EDIT_INSERT_IMAGE_REQUEST;
    readonly config: PhotosUploadConfig;
    readonly files: File[];
}
export interface ArticleEditInsertImageNormalizedResponse extends NormalizedResponse {
    readonly result: number;
}
export const ARTICLE_EDIT_INSERT_IMAGE_SUCCESS = 'ARTICLE_EDIT_INSERT_IMAGE_SUCCESS';
export interface ArticleEditInsertImageSuccessAction extends APISuccessAction<ArticleEditInsertImageNormalizedResponse> {
    readonly type: typeof ARTICLE_EDIT_INSERT_IMAGE_SUCCESS;
    readonly config: PhotosUploadConfig;
    readonly files: File[];
    readonly response: ArticleEditInsertImageNormalizedResponse;
}
export const ARTICLE_EDIT_INSERT_IMAGE_FAILURE = 'ARTICLE_EDIT_INSERT_IMAGE_FAILURE';
export interface ArticleEditInsertImageFailureAction extends APIFailureAction {
    readonly type: typeof ARTICLE_EDIT_INSERT_IMAGE_FAILURE;
    readonly config: PhotosUploadConfig;
    readonly files: File[];
}

export const articleEditInsertImageTrigger =
    (editor: any, formName: string, config: PhotosUploadConfig, files: File[], processPhotoUploadOnFormPage: FormPageType, accessKey?: string): ArticleEditInsertImageTriggerAction => ({
        type: ARTICLE_EDIT_INSERT_IMAGE_TRIGGER, editor, formName, config, files, processPhotoUploadOnFormPage, accessKey,
    });
export const articleEditInsertImageApi = {
    request: (config: PhotosUploadConfig, files: File[]): ArticleEditInsertImageRequestAction => ({
        type: ARTICLE_EDIT_INSERT_IMAGE_REQUEST, config, files,
    }),
    success: (config: PhotosUploadConfig, files: File[], response: ArticleEditInsertImageNormalizedResponse): ArticleEditInsertImageSuccessAction => ({
        type: ARTICLE_EDIT_INSERT_IMAGE_SUCCESS, config, files, response,
    }),
    failure: (config: PhotosUploadConfig, files: File[], error: any): ArticleEditInsertImageFailureAction => ({
        type: ARTICLE_EDIT_INSERT_IMAGE_FAILURE, config, files, error,
    }),
};
